module.exports = __webpack_public_path__ + "img/telegraphs.d8bfcd6d.gif";